export default __webpack_public_path__ + "static/simple-bar-d358280b6b2a638292d4457bf083492e.png";